export default {"src":"/_next/static/media/contact.343f8197.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};